import * as React from 'react';
import Button from '@material-ui/core/Button';
import FavoriteIcon from '@mui/icons-material/Favorite';

function Favorites() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Favorites</strong></p>
        <Button
          href={"/favorites"}
          size="small"
          variant="outlined"
          startIcon={<FavoriteIcon />}
        >
          View your favorite stocks
        </Button>
      </p>
    </div>
  );
}

export default Favorites;
